import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useInvoices } from '../hooks/useInvoices';
import { useInvoicesSelection } from '../hooks/useInvoicesSelection';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { Invoice } from '../types';

export const RecordsTable = () => {

    const {
        items,
        loading,
        totalCount,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useInvoices();

    const { selectedRecords, setSelectedRecords } = useInvoicesSelection();



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<Invoice>[] = [
        {
            accessor: 'id',
            title: 'Invoice',
            render: (record: Invoice) => (
                <Link to={`/invoices/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.id}
                    </Text>
                </Link>
            )
        },
        { accessor: 'status', title: 'Status' },
        { accessor: 'created', title: 'Created' },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};
